import {
  MERCHANT_GROUP_IS_AGENCY,
  MERCHANT_GROUP_NAME,
  MERCHANT_GROUP_WEBSITE,
} from "./MerchantGroupForm";
import { MerchantGroup } from "src/merchantgroups/objects/MerchantGroup";
import {
  AddIContactDataToContact,
  ContactToIContactData,
  type IContactData,
} from "src/shared/contacts/forms/inputs/contact/IContactData";

export interface IMerchantGroupData extends IContactData {
  [MERCHANT_GROUP_NAME]: string;
  [MERCHANT_GROUP_IS_AGENCY]: boolean;
  [MERCHANT_GROUP_WEBSITE]: string;
}

/**
 * @deprecated
 */
export default IMerchantGroupData;

export function IMerchantGroupDataToMerchantGroup(
  formData: IMerchantGroupData,
  merchantGroupUUID?: string,
): MerchantGroup {
  const merchantGroup: MerchantGroup = new MerchantGroup();
  if (merchantGroupUUID) {
    merchantGroup.merchantGroupUUID = merchantGroupUUID;
  }
  merchantGroup.merchantGroupName = formData[MERCHANT_GROUP_NAME];
  merchantGroup.isAgency = formData[MERCHANT_GROUP_IS_AGENCY];
  merchantGroup.webSite = formData[MERCHANT_GROUP_WEBSITE];

  AddIContactDataToContact(formData, merchantGroup);

  return merchantGroup;
}

export function MerchantGroupToIMerchantGroupData(
  merchantGroup: MerchantGroup,
): Partial<IMerchantGroupData> {
  return {
    [MERCHANT_GROUP_NAME]: merchantGroup.merchantGroupName,
    [MERCHANT_GROUP_IS_AGENCY]: merchantGroup.isAgency,
    [MERCHANT_GROUP_WEBSITE]: merchantGroup.webSite,
    ...ContactToIContactData(merchantGroup),
  };
}
